/* @refresh reload */
import { ErrorBoundary, render } from "solid-js/web";

import "./index.css";
import "./lib/sentry";
import posthog from "posthog-js";
import { API_URL, IS_RANCH_PROD, POSTHOG_KEY } from "./config";
import { App } from "@/App.tsx";
import { OpenAPI } from "@/api-client/core/OpenAPI.ts";
import { getAuthToken } from "@/components/lib/auth.ts";
import { WebApp } from "./twa-sdk-updated/core";
import { BansWrapper } from "./components/BansWrapper";
import { ErrorFallback } from "./components/ErrorFallback";
import { Toaster } from "./components/ui/toast";

// Configure the OpenAPI client. Needs to be done here because
// the OpenAPI file cannot be updated because is auto-generated.
OpenAPI.BASE = API_URL;
OpenAPI.TOKEN = getAuthToken();

if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: IS_RANCH_PROD
      ? "https://koji.kuroro.com"
      : "https://us.i.posthog.com",
    session_idle_timeout_seconds: 300,
  });
}

WebApp.ready();
WebApp.expand();
WebApp.disableVerticalSwipes();

const root = document.getElementById("root");

render(
  () => (
    <>
      {/* <ErrorBoundary fallback={(err) => <ErrorFallback error={err} />}> */}
        <BansWrapper>
          <App />
        </BansWrapper>
      {/* </ErrorBoundary> */}
      <Toaster />
    </>
  ),
  root!,
);
